import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import AdministratorContent from "./AdministratorContent";
export default class Administrator extends React.Component {
  render() {
    let id = this.props.match.params.id;

    return (
      <div class="wrapper">
        
        <Navbar />
        <Mainmenu />
        <AdministratorContent id={id} />
        <Footer />
      </div>
    );
  }
}
